import _toConsumableArray from "/codebuild/output/src145264479/src/LandingPage/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function groupOptions(_ref) {
  var data = _ref.data;
  var sortedData = [];
  var unGroupedData = [];
  var groupedData = data.reduce(function (acc, item, index) {
    if (item.group) {
      if (acc[item.group]) acc[item.group].push(index);else acc[item.group] = [index];
    } else {
      unGroupedData.push(index);
    }
    return acc;
  }, {});
  Object.keys(groupedData).forEach(function (groupName) {
    sortedData.push.apply(sortedData, _toConsumableArray(groupedData[groupName].map(function (index) {
      return data[index];
    })));
  });
  sortedData.push.apply(sortedData, _toConsumableArray(unGroupedData.map(function (itemIndex) {
    return data[itemIndex];
  })));
  return sortedData;
}
function getGroupedOptions(data) {
  var sorted = groupOptions({
    data: data
  });
  var unGrouped = [];
  var grouped = [];
  var groupName = null;
  sorted.forEach(function (item, index) {
    if (!item.group) {
      unGrouped.push({
        type: "item",
        item: item,
        index: index
      });
    } else {
      if (groupName !== item.group) {
        groupName = item.group;
        grouped.push({
          type: "label",
          label: groupName
        });
      }
      grouped.push({
        type: "item",
        item: item,
        index: index
      });
    }
  });
  return {
    grouped: grouped,
    unGrouped: unGrouped,
    items: [].concat(grouped, unGrouped),
    hasItems: grouped.length > 0 || unGrouped.length > 0
  };
}
export { getGroupedOptions, groupOptions };